import React, {useEffect} from 'react';

import {Copy, PencilSimple, Trash} from '@phosphor-icons/react';
import CSSModules from 'react-css-modules';

import type {BaseObject} from '../types';
import {ObjectTypes} from '../types';

import styles from './styles.module.scss';

export type ObjectToolbarProps = {
  handleRemoveObject: () => void;
  handleEditObject?: () => void;
  handleDuplicateObject?: () => void;
  removeText?: string;
  editText?: string;
  duplicateText?: string;
  selectedObject: BaseObject | null;
};

// eslint-disable-next-line complexity
const ObjectToolbarComponent: React.FC<ObjectToolbarProps> = ({
  handleRemoveObject,
  handleEditObject,
  handleDuplicateObject,
  removeText = 'Remove',
  editText = 'Edit',
  duplicateText = 'Duplicate',
  selectedObject,
}) => {
  useEffect(() => {
    const removeContentLayerObject = (e: KeyboardEvent) => {
      if (e.key === 'Delete' || e.key === 'Backspace') {
        if (selectedObject && !(e.target instanceof HTMLInputElement)) {
          handleRemoveObject?.();
        }
      }
    };
    document.addEventListener('keydown', removeContentLayerObject);

    return () =>
      document.removeEventListener('keydown', removeContentLayerObject);
  }, [handleRemoveObject, selectedObject]);

  return (
    <div styleName='object-toolbar' data-testid='object-toolbar'>
      {handleRemoveObject && (
        <button
          styleName='action-item'
          onClick={handleRemoveObject}
          data-automation='remove-overlay-button'
        >
          <Trash />
          <span>{removeText}</span>
        </button>
      )}
      {handleEditObject && selectedObject?.type === ObjectTypes.Text && (
        <button styleName='action-item' onClick={handleEditObject}>
          <PencilSimple />
          <span>{editText}</span>
        </button>
      )}
      {handleDuplicateObject && (
        <button styleName='action-item' onClick={handleDuplicateObject}>
          <Copy />
          <span>{duplicateText}</span>
        </button>
      )}
    </div>
  );
};

export const ObjectToolbar = CSSModules(ObjectToolbarComponent, styles);
